import { createContext, useContext } from 'react';

// Contexte de l'utilisateur connecté (entreprise, hash, adresse) lu par la carte « Brouillon
// d'e-mail » : routes /api/emails (en-têtes de contexte), domaine des adresses externes,
// signature. Fourni par App ; null hors de la plateforme.
export const EmailUserContext = createContext(null);

export const useEmailUser = () => useContext(EmailUserContext);
